
import { routeBuilder } from 'credo';
import { EntryPageComponent } from './containers/pages/entry-page/entry-page.component';

export const routes =  routeBuilder()
  .withMaintenance()
  .root({ path: 'entry', component: EntryPageComponent, data: { animation: 'entry' } })
  .build();